<!--
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-01-15 16:24:43
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-01-15 16:24:43
 -->
<template>
  <el-dropdown id="the-dropdown" @command="handleCommand">
    <div class="the-dropdown-content">
      <span class="user-name">{{ realname }}</span>
      <i class="el-icon-arrow-down el-icon--right"></i>
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item command="pageLogout">注销</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'TheDropdown',
  computed: {
    ...mapState([
      'realname',
    ]),
  },
  methods: {
    ...mapActions([
      'pageLogout',
    ]),
    handleCommand (command) {
      command && this[command]()
    },
  },
}
</script>

<style lang="less" scoped>
#the-dropdown {
  .the-dropdown-content {
    cursor: pointer;

    .user-name {
      color: #666;
      font-size: 14px;
      margin-right: 6px;
    }
  }
}
</style>
